// ─── Elegant Wedding V1 ───────────────────────────────────────
// Config-driven rebuild of PremiumStory template.
// Same visual output, assembled from section components + tokens.

export const elegantWeddingV1 = {
  templateId: 'elegant-wedding-v1',
  name: 'Elegant Wedding',
  category: 'wedding',
  description: 'Cinematic mobile-first storytelling with countdown, map, FAQ, and floating controls',
  theme: {
    palette: 'warm-story',
    fontPair: 'playfair-inter',
    radius: 'soft',
    shadow: 'soft',
    overlay: 'warm-soft',
    sectionSpacing: { mobileY: '4rem', desktopY: '6rem' },
  },
  settings: {
    musicEnabled: true,
    countdownEnabled: true,
    rsvpEnabled: true,
    showMapLink: true,
  },
  sections: [
    {
      id: 'hero-1',
      type: 'hero',
      variant: 'hero-centered-image',
      animation: { title: 'stagger-text', subtitle: 'fade-up', cta: 'fade-up', background: 'parallax-soft', image: 'zoom-soft' },
      visible: true,
      editableRules: {
        fields: ['introLabel', 'title', 'subtitle', 'dateText', 'backgroundImage', 'ctaText', 'ctaTarget'],
        selectable: ['palette'],
        locked: ['layout', 'spacing', 'typographyScale', 'responsiveRules'],
      },
      data: {
        introLabel: "We're getting married",
        title: 'Sofia & Miguel',
        subtitle: '',
        dateText: '',
        backgroundImage: '',
        ctaText: 'Open Invitation',
        ctaTarget: 'rsvp',
      },
    },
    {
      id: 'story-1',
      type: 'story',
      variant: 'story-single-column',
      animation: { text: 'fade-up' },
      visible: true,
      editableRules: {
        fields: ['title', 'paragraph', 'secondaryParagraph'],
        locked: ['layout', 'spacing', 'textWidth'],
      },
      data: {
        title: 'With Love',
        paragraph: 'Together with our families, we joyfully invite you to celebrate the beginning of our new life together. Your presence would mean the world to us.',
        secondaryParagraph: '',
      },
    },
    {
      id: 'countdown-1',
      type: 'countdown',
      variant: 'countdown-centered',
      animation: { section: 'fade-in' },
      visible: true,
      editableRules: {
        fields: ['targetDateTime', 'label'],
        locked: ['timerLogic', 'layout', 'spacing', 'format'],
      },
      data: {
        targetDateTime: '',
        label: 'Counting Down',
      },
    },
    {
      id: 'details-1',
      type: 'event-details',
      variant: 'details-grid',
      animation: { items: 'stagger-cards' },
      visible: true,
      editableRules: {
        fields: ['items', 'venue', 'address'],
        locked: ['grid', 'iconStyle', 'spacing'],
      },
      data: {
        items: [],
        venue: '',
        address: '',
      },
    },
    {
      id: 'gallery-1',
      type: 'gallery',
      variant: 'gallery-grid',
      animation: { items: 'zoom-soft' },
      visible: true,
      editableRules: {
        fields: ['images', 'captions'],
        locked: ['grid', 'gap', 'imageRatio'],
      },
      data: {
        images: [],
        captions: [],
      },
    },
    {
      id: 'rsvp-1',
      type: 'rsvp',
      variant: 'rsvp-card',
      animation: { section: 'fade-up' },
      visible: true,
      editableRules: {
        fields: ['title', 'description', 'deadline', 'submitLabel'],
        locked: ['validationRules', 'inputStyle', 'spacing'],
      },
      data: {
        title: 'RSVP',
        description: "We'd love to know if you can make it",
        deadline: '',
        submitLabel: 'Send RSVP',
      },
    },
    {
      id: 'venue-1',
      type: 'venue',
      variant: 'venue-card',
      animation: { section: 'fade-up' },
      visible: true,
      editableRules: {
        fields: ['venueName', 'address', 'mapLink', 'note'],
        locked: ['cardLayout', 'buttonStyle', 'spacing'],
      },
      data: {
        venueName: '',
        address: '',
        mapLink: '',
        note: '',
      },
    },
    {
      id: 'faq-1',
      type: 'faq',
      variant: 'faq-accordion',
      animation: { section: 'fade-up' },
      visible: true,
      editableRules: {
        fields: ['items'],
        locked: ['layout', 'spacing'],
      },
      data: {
        items: [],
      },
    },
    {
      id: 'footer-1',
      type: 'footer',
      variant: 'footer-centered',
      animation: { section: 'fade-up' },
      visible: true,
      editableRules: {
        fields: ['closingMessage', 'names', 'contactText'],
        locked: ['layout', 'spacing', 'typographyScale'],
      },
      data: {
        closingMessage: "We can't wait to celebrate with you",
        names: 'Sofia & Miguel',
        contactText: 'Made with love',
      },
    },
  ],
};
